function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 0%;\n  height: 100%;\n  font-family: SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier,\n    monospace;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgb(103, 121, 141);\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-right: 6px;\n  border: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 32px;\n\n  .focus-border {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    width: 0;\n    height: 2px;\n    background-color: #d3eadc;\n    transition: 0.4s;\n  }\n\n  &:hover {\n    .focus-border {\n      width: 100%;\n      transition: 0.4s;\n      left: 0;\n    }\n  }\n\n  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n    padding: 0;\n  }\n\n  .ant-select-single .ant-select-selector .ant-select-selection-search {\n    position: absolute;\n    top: 0;\n    right: 11px;\n    bottom: 0;\n    left: 0px;\n  }\n\n  .ant-form-item-explain {\n    z-index: 100;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import { Input, Form, AutoComplete } from 'antd';
import styled from 'styled-components';
var {
  TextArea
} = Input;
export var StyledFormItem = styled(Form.Item)(_templateObject());

function TextInputWithEnums(_ref) {
  var {
    name,
    options,
    checkParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledFormItem, {
    key: name,
    name: [name, 'value'],
    rules: [{
      validator: (rule, value) => checkParameter(rule, value)
    }]
  }, /*#__PURE__*/React.createElement(AutoComplete, {
    style: {
      display: 'block',
      padding: 0,
      height: 300
    },
    bordered: false,
    options: options,
    placeholder: "Enter a ".concat(name, " value")
  }, /*#__PURE__*/React.createElement(TextArea, {
    className: "custom",
    style: {
      resize: 'none',
      height: 275
    }
  }))));
}

export default TextInputWithEnums;